module.exports = __webpack_public_path__ + "img/skillset-gfx-2.23604696.png";